/**
 * @generated SignedSource<<a987f620407e83d27f41bba7e4c78a10>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type IncompleteProfileBadge_profile$data = {
  readonly visitorCanEdit: boolean;
  readonly " $fragmentType": "IncompleteProfileBadge_profile";
};
export type IncompleteProfileBadge_profile$key = {
  readonly " $data"?: IncompleteProfileBadge_profile$data;
  readonly " $fragmentSpreads": FragmentRefs<"IncompleteProfileBadge_profile">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "IncompleteProfileBadge_profile",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "visitorCanEdit",
      "storageKey": null
    }
  ],
  "type": "UserProfile",
  "abstractKey": null
};

(node as any).hash = "79fcc5be55e9c498724d9e21a98ed041";

export default node;
